import { BR_VISIT } from 'constants/braze/brazeEvents';
import { BR_COUNTRY, BR_LANGUAGE, BR_TIME, BR_WEB_NAME, BR_WEB_URL } from 'constants/braze/brazeParams';

import Cookies from 'universal-cookie';

const sdkEndpoint = process.env.BRAZE_SDK_ENDPOINT;
const ApiKey = process.env.BRAZE_API_KEY;
const TRY_COUNTER = __isDev__ ? 0 : 5;
export const brazeScript = 'https://js.appboycdn.com/web-sdk/5.7/braze.min.js';

const cookies = new Cookies();

export const brazeInit = () => {
    if (__isBrowser__) {
        const addBrazeScript = () => {
            +(function (a, p, P, b, y) {
                a.braze = {};
                a.brazeQueue = [];
                for (
                    var s =
                            'BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson Banner CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardImpressions logContentCardClick logContentCardsDisplayed logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags'.split(
                                ' ',
                            ),
                        i = 0;
                    i < s.length;
                    i++
                ) {
                    for (var m = s[i], k = a.braze, l = m.split('.'), j = 0; j < l.length - 1; j++) k = k[l[j]];
                    k[l[j]] = new Function('return function ' + m.replace(/\./g, '_') + '(){window.brazeQueue.push(arguments); return true}')();
                }
                window.braze.getCachedContentCards = function () {
                    return new window.braze.ContentCards();
                };
                window.braze.getCachedFeed = function () {
                    return new window.braze.Feed();
                };
                window.braze.getUser = function () {
                    return new window.braze.User();
                };
                window.braze.getFeatureFlag = function () {
                    return new window.braze.FeatureFlag();
                };
                (y = p.createElement(P)).type = 'text/javascript';
                y.src = 'https://js.appboycdn.com/web-sdk/5.7/braze.min.js';
                y.async = 1;
                (b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b);
            })(window, document, 'script');
        };
        addBrazeScript();
        let timerId = null;
        let counter = 1;
        if (typeof braze !== 'undefined') {
            init();
        } else {
            timerId = setInterval(() => init(counter++, timerId), 700);
        }
    }
};

const init = (counter, timerId) => {
    if (typeof braze !== 'undefined') {
        braze.initialize(ApiKey, {
            baseUrl: sdkEndpoint,
        });
        // Use to enable verbose logs when needed
        // if (__isDev__) {
        //     braze.toggleLogging();
        // }
        clearInterval(timerId);
    } else if (counter >= TRY_COUNTER) {
        clearInterval(timerId);
    }
};

const checkBrazeInit = () => {
    return braze.initialize(ApiKey, {
        baseUrl: sdkEndpoint,
    });
};

export const brazeChangeUser = (ballId) => {
    let timerId = null;
    let counter = 1;
    if (ballId) {
        if (typeof braze !== 'undefined') {
            pushBrazeChangeUser(ballId);
        } else {
            timerId = setInterval(() => pushBrazeChangeUser(ballId, counter++, timerId), 700);
        }
    }
};

const pushBrazeChangeUser = (ballId, counter, timerId) => {
    if (typeof braze !== 'undefined') {
        const isInitialized = checkBrazeInit();
        if (isInitialized) {
            const isLoggedIn = sessionStorage?.getItem('isLoggedIn');
            if (isLoggedIn !== 'true') {
                braze.changeUser(ballId);
            }
            braze.openSession();
        }
        sessionStorage?.setItem('isLoggedIn', 'true');
        clearInterval(timerId);
    } else if (counter >= TRY_COUNTER) {
        clearInterval(timerId);
    }
};

export const sendBrazeEvent = (eventName, params = {}) => {
    let timerId = null;
    let counter = 1;

    if (typeof braze !== 'undefined') {
        pushBrazeEvent(eventName, params);
    } else {
        timerId = setInterval(() => pushBrazeEvent(eventName, params, counter++, timerId), 700);
    }
};

const pushBrazeEvent = (eventName, params, counter, timerId) => {
    if (typeof braze !== 'undefined') {
        const isInitialized = checkBrazeInit();
        if (isInitialized) {
            braze.logCustomEvent(eventName, params);
        }
        clearInterval(timerId);
    } else if (counter >= TRY_COUNTER) {
        clearInterval(timerId);
    }
};

export const brazePgaViewEvent = (url, pageTitle, app, auth, lang) => {
    let timerId = null;
    let counter = 1;
    if (typeof braze !== 'undefined') {
        pushBrazePgaViewEvent(url, pageTitle, app, auth, lang);
    } else {
        timerId = setInterval(() => pushBrazePgaViewEvent(url, pageTitle, app, auth, lang, counter++, timerId), 700);
    }
};

const pushBrazePgaViewEvent = (url, pageTitle, app, auth, lang, counter, timerId) => {
    const { country } = app;
    let params = {
        [BR_WEB_URL]: url,
        [BR_WEB_NAME]: pageTitle,
        [BR_LANGUAGE]: lang,
        [BR_COUNTRY]: country,
        [BR_TIME]: new Date().toString(),
    };

    if (typeof braze !== 'undefined') {
        const isInitialized = checkBrazeInit();
        if (isInitialized) {
            if (!cookies.get(BR_VISIT)) {
                const date = new Date();
                date.setDate(date.getDate() + 60 * 24 * 365);
                cookies.set(BR_VISIT, 1, { path: '/', secure: true, expires: date });
                braze.logCustomEvent(BR_VISIT, params);
            }
        }
        clearInterval(timerId);
    } else if (counter >= TRY_COUNTER) {
        clearInterval(timerId);
    }
};

export const fetchContentCards = (ballId, onCardsFetched) => {
    if (!ballId || typeof window === 'undefined') {
        return;
    }
    let attempts = 0;
    const maxAttempts = 5;

    const intervalId = setInterval(() => {
        if (typeof braze !== 'undefined' && braze.openSession) {
            clearInterval(intervalId);
            braze.openSession();
            braze.changeUser(ballId);
            braze.subscribeToContentCardsUpdates((event) => {
                const cards = event.cards || [];
                if (onCardsFetched) onCardsFetched(cards);
            });
            braze.requestContentCardsRefresh();
        } else if (++attempts >= maxAttempts) {
            clearInterval(intervalId);
            console.warn('[fetchContentCards] Braze did not initialize in time');
        }
    }, 300);

    return () => clearInterval(intervalId);
};
